"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineLazyKeyStore = defineLazyKeyStore;
exports.registerLazyKeyService = registerLazyKeyService;
exports.LazyKeyServiceState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionSteps = require("../actions/ActionSteps");

var _ActionVerbs = require("../actions/ActionVerbs");

var _Dispatch = require("../dispatch/Dispatch");

var _MakeActions = require("../actions/MakeActions");

var _enviro = _interopRequireDefault(require("enviro"));

var _generalStore = _interopRequireDefault(require("general-store"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _registerService2 = _interopRequireDefault(require("../flux/registerService"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var LazyKeyServiceState = (0, _immutable.Record)({
  pending: (0, _immutable.Set)(),
  queue: (0, _immutable.Set)()
}, 'LazyKeyServiceState');
exports.LazyKeyServiceState = LazyKeyServiceState;

function isIterable(ids) {
  return _immutable.Iterable.isIterable(ids) || Array.isArray(ids);
}

function baseFillUnfoundKeys(idTransform, keys, result) {
  // if any keys are missing we fill them with null so
  // we know they don't exist
  return keys.reduce(function (filled, key) {
    return filled.set(idTransform(key), result.get(key) || null);
  }, (0, _immutable.Map)());
}

function enforceId(idIsValid, namespace, id) {
  (0, _invariant.default)(idIsValid(id), '`%s` expected `idIsValid` to return true for id: `%s`', namespace, JSON.stringify(id));
  return id;
}

function baseNormalizeIds(idIsValid, idTransform, namespace, ids) {
  if (idIsValid(ids)) {
    return _immutable.Seq.of(idTransform(ids));
  }

  (0, _invariant.default)(isIterable(ids), '`%s` expected `ids` to be an `Iterable` or an `Array` but got `%s`', namespace, ids);
  return (0, _immutable.Seq)(ids).map(enforceId.bind(null, idIsValid, namespace)).map(idTransform);
}

function defineLazyKeyStore(_ref) {
  var namespace = _ref.namespace,
      _ref$getInitialState = _ref.getInitialState,
      getInitialState = _ref$getInitialState === void 0 ? _immutable.Map : _ref$getInitialState,
      idIsValid = _ref.idIsValid,
      _ref$idTransform = _ref.idTransform,
      idTransform = _ref$idTransform === void 0 ? _identity.default : _ref$idTransform,
      _ref$responseTransfor = _ref.responseTransform,
      responseTransform = _ref$responseTransfor === void 0 ? _identity.default : _ref$responseTransfor;
  (0, _invariant.default)(typeof idIsValid === 'function', 'expected `idIsValid` to be a function but got `%s`', idIsValid);
  var FetchTypes = (0, _MakeActions.makeAsyncActionTypes)(namespace, _ActionVerbs.FETCH);
  var DELETE_SUCCEEDED = (0, _MakeActions.makeAsyncActionType)(namespace, _ActionVerbs.DELETE, _ActionSteps.SUCCEEDED);
  var UPDATED = namespace + "_UPDATED";
  var CLEARED = (0, _MakeActions.makeAction)(namespace, 'CLEARED');
  var normalizeIds = baseNormalizeIds.bind(null, idIsValid, idTransform, namespace);
  return _generalStore.default.defineFactory().defineName(namespace + "_LazyKeyStore").defineGetInitialState(getInitialState).defineGet(function (state, ids) {
    if (ids === undefined) {
      if (!_enviro.default.deployed() || _enviro.default.getShort() !== 'prod') {
        var warningInfo = {
          message: "Calling LazyKeyStore.get() with no arguments is a debugging feature. It isn't safe for production!",
          url: 'https://git.hubteam.com/HubSpot/CRM/pull/4291',
          key: 'LazyKeyStore:getWarning'
        };

        _devLogger.default.warn(warningInfo);
      }

      return state;
    }

    var idList = normalizeIds(ids);

    if (idList.isEmpty()) {
      return ids;
    }

    var missing = (0, _immutable.Seq)(idList).filterNot(function (id) {
      return state.has(id);
    }).toSet();

    if (!missing.isEmpty()) {
      // sends the missing ids to the LazyKeyService to be fetched
      (0, _Dispatch.dispatchQueue)(FetchTypes.QUEUED, missing).done();
    } // if it's a single id, just return the value


    if (idIsValid(ids)) {
      return state.get(idTransform(ids));
    }

    return ids.map(function (id) {
      return state.get(idTransform(id));
    });
  }).defineResponseTo(DELETE_SUCCEEDED, function (state, keys) {
    return state.withMutations(function (nextState) {
      keys.forEach(function (key) {
        return nextState.set(idTransform(key), null);
      });
      return nextState;
    });
  }).defineResponseTo(FetchTypes.SUCCEEDED, function (state, newObjects) {
    return newObjects.reduce(function (acc, entry, key) {
      return acc.set(idTransform(key), responseTransform(entry, key));
    }, state);
  }).defineResponseTo(UPDATED, function (state, updatedObjectFragments) {
    return state.mergeDeep(updatedObjectFragments.reduce(function (acc, val, key) {
      return acc.set(idTransform(key), val);
    }, (0, _immutable.Map)()));
  }).defineResponseTo(CLEARED, function () {
    return getInitialState();
  });
}

function registerLazyKeyService(_ref2) {
  var _registerService;

  var namespace = _ref2.namespace,
      fetch = _ref2.fetch,
      _ref2$idTransform = _ref2.idTransform,
      idTransform = _ref2$idTransform === void 0 ? _identity.default : _ref2$idTransform,
      fetchLimit = _ref2.fetchLimit;
  (0, _invariant.default)(typeof fetch === 'function', 'expected `fetch` to be a function but got `%s`', fetch);
  var FetchTypes = (0, _MakeActions.makeAsyncActionTypes)(namespace, _ActionVerbs.FETCH);
  var RefreshTypes = (0, _MakeActions.makeAsyncActionTypes)(namespace, _ActionVerbs.REFRESH);
  var fillUnfoundKeys = baseFillUnfoundKeys.bind(null, idTransform);

  var handleQueued = function handleQueued(state, ids) {
    var pending = state.pending,
        queue = state.queue;
    var newIds = ids.toSet().subtract(pending, queue);

    if (newIds.isEmpty()) {
      return state;
    }

    (0, _Dispatch.dispatchQueue)(FetchTypes.STARTED).done();
    return state.set('queue', queue.union(newIds));
  };

  var handleStarted = function handleStarted(state) {
    var pending = state.pending,
        queue = state.queue;

    if (queue.isEmpty()) {
      return state;
    }

    var fetchQueue = fetchLimit && queue.size > fetchLimit ? queue.slice(0, fetchLimit) : queue;
    var waitQueue = fetchLimit && queue.size > fetchLimit ? queue.slice(fetchLimit) : (0, _immutable.Set)();
    fetch(fetchQueue.toList()).then(function (result) {
      (0, _Dispatch.dispatchImmediate)(FetchTypes.SUCCEEDED, fillUnfoundKeys(fetchQueue, result));

      if (waitQueue.size) {
        (0, _Dispatch.dispatchQueue)(FetchTypes.QUEUED, waitQueue);
      } // FIXME: ideally we want to dispatch SETTLED even when the request
      // fails but we don't want that request to be retried forever


      return (0, _Dispatch.dispatchQueue)(FetchTypes.SETTLED, fetchQueue);
    }, function (error) {
      return (0, _Dispatch.dispatchImmediate)(FetchTypes.FAILED, error);
    }).done();
    return state.merge({
      pending: pending.union(fetchQueue),
      queue: (0, _immutable.Set)()
    });
  };

  return (0, _registerService2.default)(LazyKeyServiceState(), (_registerService = {}, (0, _defineProperty2.default)(_registerService, FetchTypes.QUEUED, handleQueued), (0, _defineProperty2.default)(_registerService, RefreshTypes.QUEUED, handleQueued), (0, _defineProperty2.default)(_registerService, FetchTypes.STARTED, handleStarted.bind(this)), (0, _defineProperty2.default)(_registerService, FetchTypes.SETTLED, function (state, keys) {
    var pending = state.pending;
    return state.set('pending', pending.subtract(keys));
  }), _registerService));
}